<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label='收入名称'>
                <el-input v-model='queryForm.incomeName'></el-input>
            </el-form-item>
            <el-form-item label='奖金名称'>
                <el-input v-model='queryForm.bonusName'></el-input>
            </el-form-item>
            <el-form-item label='比例'>
                <el-input v-model='queryForm.incomeRatio'></el-input>
            </el-form-item>
            <el-form-item label='收入总金额'>
                <el-input v-model='queryForm.totalMoney'></el-input>
            </el-form-item>
            <el-form-item label='未发放金额'>
                <el-input v-model='queryForm.unsentMoney'></el-input>
            </el-form-item>
            <el-form-item label='发放类型'>
                <el-input v-model='queryForm.sendType'></el-input>
            </el-form-item>
            <el-form-item label='类型对应的ID'>
                <el-input v-model='queryForm.typeId'></el-input>
            </el-form-item>
            <el-form-item label='发放方式'>
                <el-input v-model='queryForm.sendWay'></el-input>
            </el-form-item>
            <el-form-item label='执行方式'>
                <el-input v-model='queryForm.executeWay'></el-input>
            </el-form-item>
            <el-form-item label='发放间隔，单位：分钟'>
                <el-input v-model='queryForm.sendInterval'></el-input>
            </el-form-item>
            <el-form-item label='发放次数'>
                <el-input v-model='queryForm.sendTimes'></el-input>
            </el-form-item>
            <el-form-item label='最后一次发放时间'>
                <el-input v-model='queryForm.updateTime'></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getShopIncomeList'>查询</el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-plus'
                        @click='addShopIncome'
                    >新建
                    </el-button>
                    <el-button
                        type='warning'
                        plain
                        size='small'
                        icon='el-icon-edit'
                        :disabled='multipleSelection.length != 1'
                        @click='editShopIncome(null)'
                    >修改
                    </el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteShopIncome(null)'
                    >删除
                    </el-button>
                </div>

                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <!--        <span-->
                    <!--          title="搜索"-->
                    <!--          class="icon-box"-->
                    <!--          @click="search"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <Search />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportShopIncomeList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class='icon-box'
                        @click='refreshShopIncomeList'
                    >
          <Icon color='#606266'>
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data='shopIncomeList'
                row-key='id'
                height='100%'
                border
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='incomeName'
                    label='分红名称'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='bonusName'
                    label='奖金名称'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='incomeRatio'
                    label='分红比例'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='totalMoney'
                    label='收入总金额'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='unsentMoney'
                    label='未发放金额'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='currencyType'
                    label='发放货币'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ computeCurrencyType(scope.row.currencyType) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='sendType'
                    label='发放类型'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ computeSendType(scope.row.sendType) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='typeId'
                    label='发放对象'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div v-if='scope.row.sendType == 1 && scope.row.user'>{{ scope.row.user.userName }}</div>
                        <div v-if='scope.row.sendType == 2 && scope.row.grade'>{{ scope.row.grade.gradeName }}</div>
                        <div v-if='scope.row.sendType == 3 && scope.row.agentLevel'>{{ scope.row.agentLevel.agentName }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='sendWay'
                    label='发放方式'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ computeSendWay(scope.row.sendWay) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='executeWay'
                    label='执行方式'
                    width='180'
                >
                    <template slot-scope='scope'>
                        <div>{{ computeExecuteWay(scope.row.executeWay) }}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='sendInterval'
                    label='发放间隔'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='sendTimes'
                    label='发放次数'
                    width='180'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='lastSendTime'
                    label='最后发放时间'
                    width='180'
                ></el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='350'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div>
                                <el-button
                                    @click='sendDividend(scop.row)'
                                    type='primary'
                                    size='small'
                                >发放
                                </el-button>
                            </div>
                            <div @click='checkShopIncome(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看</span>
                            </div>
                            <div @click='getCount(scop.row.id)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>发放条数</span>
                            </div>
                            <div @click='editShopIncome(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteShopIncome(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='shopIncomeStates[shopIncomeState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        :model='shopIncome'
                        ref='shopIncomeForm'
                        :rules='rules'
                        label-width='120px'
                        :inline='true'
                        size='small'
                    >
                        <el-form-item
                            label='分红名称'
                            prop='incomeName'
                        >
                            <el-input
                                size='small'
                                v-model='shopIncome.incomeName'
                                :disabled="shopIncomeState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='奖金名称'
                            prop='bonusName'
                        >
                            <el-input
                                size='small'
                                v-model='shopIncome.bonusName'
                                :disabled="shopIncomeState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='分红比例'
                            prop='incomeRatio'
                        >
                            <el-input
                                size='small'
                                v-model='shopIncome.incomeRatio'
                                :disabled="shopIncomeState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='收入总金额'
                            prop='totalMoney'
                        >
                            <el-input
                                size='small'
                                v-model='shopIncome.totalMoney'
                                :disabled="shopIncomeState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='未发放金额'
                            prop='unsentMoney'
                        >
                            <el-input
                                size='small'
                                v-model='shopIncome.unsentMoney'
                                :disabled="shopIncomeState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='发放货币'
                            prop='currencyType'
                        >
                            <el-select
                                v-model='shopIncome.currencyType'
                                placeholder='请选择发放货币类型'
                                size='small'
                                clearable
                                style='width: 176px'
                                :disabled="shopIncomeState == 'check'"
                            >
                                <el-option
                                    v-for='item in currencyTypeEnumList'
                                    :key='item.key'
                                    :label='item.value'
                                    :value='item.key'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='发放类型'
                            prop='sendType'
                        >
                            <el-select
                                v-model='shopIncome.sendType'
                                placeholder='请选择发放类型'
                                size='small'
                                clearable
                                style='width: 176px'
                                :disabled="shopIncomeState == 'check'"
                            >
                                <el-option
                                    v-for='item in incomeSendTypeEnumList'
                                    :key='item.key'
                                    :label='item.value'
                                    :value='item.key'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            v-if="shopIncome.sendType != 1 && shopIncome.sendType != 4"
                            label='指定类型ID'
                            prop='typeId'
                        >


                            <GridSelect
                                title='选择用户'
                                labelName='userName'
                                labelValue='id'
                                :disabled="shopIncome.sendType == '' || shopIncomeState == 'check'"
                                v-if="shopIncome.sendType == 2"
                                :value='shopIncome.typeId'
                                :limit='1'
                                style='width: 176px'
                                size='small'
                                placeholder='请选择用户'
                                @getValue='getValue'
                                :columns="USER_code"
                                :searchs="USER_search"
                                dataListUrl='/mpp/user/findList'
                                entityBeanName='mppUser'
                                queryEntityUrl='/mpp/user/get'
                            >
                            </GridSelect>
                            <el-select
                                style="width: 176px;"
                                clearable
                                v-model='shopIncome.typeId'
                                :disabled="shopIncome.sendType == '' || shopIncomeState == 'check'"
                                size='small'
                                v-else-if="shopIncome.sendType  == 3"
                                placeholder='请选择用户等级'
                            >
                                <el-option v-for='(item,index) in mppGradeList' :label='item.gradeName' :value='item.id'></el-option>
                            </el-select>
                            <el-select
                                style="width: 176px;"
                                clearable
                                v-model='shopIncome.typeId'
                                :disabled="shopIncome.sendType == '' || shopIncomeState == 'check'"
                                size='small'
                                v-else
                                placeholder='请选择代理等级'
                            >
                                <el-option v-for='(item,index) in agentLevelEnumList' :label='item.agentName' :value='item.id'></el-option>
                            </el-select>





<!--                            <GridSelect-->
<!--                                style='width: 180px'-->
<!--                                title='选择用户'-->
<!--                                labelName='userName'-->
<!--                                labelValue='id'-->
<!--                                :value='shopIncome.typeId'-->
<!--                                :limit='1'-->
<!--                                :disabled="esignContract.signTarget == '' || shopIncomeState == 'check'"-->
<!--                                v-if="esignContract.signTarget == 2"-->
<!--                                size='small'-->
<!--                                placeholder='请选择用户'-->
<!--                                :disabled="shopIncomeState == 'check'"-->
<!--                                @getValue='getValue'-->
<!--                                :columns="USER_code"-->
<!--                                :searchs="USER_search"-->
<!--                                dataListUrl='/mpp/user/findList'-->
<!--                                entityBeanName='mppUser'-->
<!--                                queryEntityUrl='/mpp/user/get'-->
<!--                            >-->
<!--                            </GridSelect>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            v-if='shopIncome.sendType == 2'-->
<!--                            label='指定用户等级'-->
<!--                            prop='gradeId'-->
<!--                        >-->
<!--                            <el-select-->
<!--                                size='small'-->
<!--                                v-model='shopIncome.typeId'-->
<!--                                placeholder='请选择'-->
<!--                                :disabled="shopIncomeState == 'check'"-->
<!--                                style='width: 180px'-->
<!--                            >-->
<!--                                <el-option-->
<!--                                    v-for='item in mppGradeList'-->
<!--                                    :key='item.id'-->
<!--                                    :label='item.gradeName'-->
<!--                                    :value='item.id'-->
<!--                                >-->
<!--                                </el-option>-->
<!--                            </el-select>-->
<!--                        </el-form-item>-->
<!--                        <el-form-item-->
<!--                            v-if='shopIncome.sendType == 3'-->
<!--                            label='指定代理等级'-->
<!--                            prop='agentLevelId'-->
<!--                        >-->
<!--                            <el-select-->
<!--                                size='small'-->
<!--                                v-model='shopIncome.typeId'-->
<!--                                placeholder='请选择'-->
<!--                                :disabled="shopIncomeState == 'check'"-->
<!--                                style='width: 180px'-->
<!--                            >-->
<!--                                <el-option-->
<!--                                    v-for='item in agentLevelEnumList'-->
<!--                                    :key='item.id'-->
<!--                                    :label='item.agentName'-->
<!--                                    :value='item.id'-->
<!--                                >-->
<!--                                </el-option>-->
<!--                            </el-select>-->
                        </el-form-item>
                        <el-form-item
                            label='发放方式'
                            prop='sendWay'
                        >
                            <el-select
                                v-model='shopIncome.sendWay'
                                placeholder='请选择发放方式'
                                size='small'
                                clearable
                                style='width: 176px'
                                :disabled="shopIncomeState == 'check'"
                            >
                                <el-option
                                    v-for='item in incomeSendWayEnumList'
                                    :key='item.key'
                                    :label='item.value'
                                    :value='item.key'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='执行方式'
                            prop='executeWay'
                        >
                            <el-select
                                v-model='shopIncome.executeWay'
                                placeholder='请选择执行方式'
                                size='small'
                                clearable
                                style='width: 176px'
                                :disabled="shopIncomeState == 'check'"
                            >
                                <el-option
                                    v-for='item in incomeExecuteWayEnumList'
                                    :key='item.key'
                                    :label='item.value'
                                    :value='item.key'
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='发放间隔'
                            prop='sendInterval'
                        >
                            <el-input
                                placeholder='”单位:分钟“'
                                size='small'
                                v-model='shopIncome.sendInterval'
                                :disabled="shopIncomeState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='发放次数'
                            prop='sendTimes'
                        >
                            <el-input
                                size='small'
                                v-model='shopIncome.sendTimes'
                                :disabled="shopIncomeState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='最后发放时间'
                            prop='lastSendTime'
                        >
                            <el-date-picker
                                style='width: 176px'
                                v-model='shopIncome.lastSendTime'
                                :disabled="shopIncomeState == 'check'"
                                type='datetime'
                                format='yyyy-MM-dd HH:mm:ss'
                                value-format='yyyy-MM-dd HH:mm:ss'
                                placeholder='选择日期时间'>
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>
                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="shopIncomeState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import GridSelect from '@/components/gridselect';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { USER, USER_SEARCH } from '@/utils/constant';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelect
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetShopIncomeList();
                this.getShopIncomeList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetShopIncomeList();
                this.getShopIncomeList();
                this.$emit('resetCheckState');
            }
        },
        'shopIncome.sendType'(newVlaue,old) {
            console.log('1111111111111111111111');
            if (this.clearTypeId) {
                this.clearTypeId = false;
                return;
            } else {
                this.shopIncome.typeId = '';
            }
            if(newVlaue != old){
                this.shopIncome.typeId = '';
            }
        },
    },
    data() {
        return {
            USER_code: USER,
            USER_search: USER_SEARCH,
            incomeExecuteWayEnumList: [],
            incomeSendWayEnumList: [],
            incomeSendTypeEnumList: [],
            currencyTypeEnumList: [],
            mppGradeList: [],
            agentLevelEnumList: [],
            clearTypeId: true,

            queryForm: {
                incomeName: '', //收入名称
                bonusName: '', //奖金名称
                incomeRatio: '', //比例
                totalMoney: '', //收入总金额
                unsentMoney: '', //未发放金额
                sendType: '', //发放类型 1指定人 2指定等级 3指定代理等级
                typeId: '', //类型对应的ID
                sendWay: '', //发放方式 1平均 2加权
                executeWay: '', //执行方式 1手动 2自动
                sendInterval: '', //发放间隔，单位：分钟
                sendTimes: '', //发放次数
                updateTime: '' //
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            shopIncomeState: 'add',
            shopIncomeStates: {
                add: '新建分红规则',
                check: '查看分红规则',
                edit: '修改分红规则'
            },

            multipleSelection: [],
            shopIncomeList: [],
            shopIncome: {
                incomeName: '', //收入名称
                bonusName: '', //奖金名称
                incomeRatio: '', //比例
                totalMoney: '', //收入总金额
                unsentMoney: '', //未发放金额
                currencyType: '', //发放货币类型
                sendType: '', //发放类型 1指定人 2指定等级 3指定代理等级
                typeId: '', //类型对应的ID
                sendWay: '', //发放方式 1平均 2加权
                executeWay: '', //执行方式 1手动 2自动
                sendInterval: '', //发放间隔，单位：分钟
                sendTimes: '', //发放次数
                lastSendTime: '' //最后一次发放时间
            },
            btnLoading: false,

            rules: {
                incomeName: [{ required: true, message: '收入名称不能为空', trigger: 'blur' }],
                bonusName: [{ required: true, message: '奖金名称不能为空', trigger: 'blur' }],
                incomeRatio: [{ required: true, message: '比例不能为空', trigger: 'blur' }],
                totalMoney: [{ required: true, message: '收入总金额不能为空', trigger: 'blur' }],
                unsentMoney: [{ required: true, message: '未发放金额不能为空', trigger: 'blur' }],
                currencyType: [{ required: true, message: '发放货币类型不能为空', trigger: 'blur' }],
                sendType: [{ required: true, message: '发放类型不能为空', trigger: 'blur' }],
                sendWay: [{ required: true, message: '发放方式不能为空', trigger: 'blur' }],
                executeWay: [{ required: true, message: '执行方式不能为空', trigger: 'blur' }],
                sendInterval: [{ required: true, message: '发放间隔不能为空', trigger: 'blur' }],
                sendTimes: [{ required: true, message: '发放次数不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.getShopIncomeList();
        this.getIncomeExecuteWayEnum();
        this.getIncomeSendWayEnum();
        this.getIncomeSendTypeEnum();
        this.getCurrencyTypeEnum();
        this.getMppGradeList();
        this.getAgentLevelEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        // 发放条数
        getCount(id){
            get('mpp/utils/getIncomeSendCount',{id:id}).then((res)=>{
                if(res.success){
                    this.$message.success(res.data)
                }else{
                    this.$message.error('获取失败')
                }
            })
        },
        resetShopIncomeList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.shopIncomeList = [];
        },
        resetDialog() {
            this.shopIncomeState = 'add';
            this.showDialog = false;
            this.queryForm = {
                incomeName: '', //收入名称
                bonusName: '', //奖金名称
                incomeRatio: '', //比例
                totalMoney: '', //收入总金额
                unsentMoney: '', //未发放金额
                currencyType: '', //发放货币类型
                sendType: '', //发放类型 1指定人 2指定等级 3指定代理等级
                typeId: '', //类型对应的ID
                sendWay: '', //发放方式 1平均 2加权
                executeWay: '', //执行方式 1手动 2自动
                sendInterval: '', //发放间隔，单位：分钟
                sendTimes: '', //发放次数
                updateTime: '' //
            };
            this.getShopIncomeList();
        },
        closeDialog() {
            this.showDialog = false;
            this.clearTypeId = true;
            this.shopIncome = {
                incomeName: '', //收入名称
                bonusName: '', //奖金名称
                incomeRatio: '', //比例
                totalMoney: '', //收入总金额
                unsentMoney: '', //未发放金额
                typeId: '', //类型对应的ID
                sendType: '', //发放类型 1指定人 2指定等级 3指定代理等级
                sendWay: '', //发放方式 1平均 2加权
                executeWay: '', //执行方式 1手动 2自动
                sendInterval: '', //发放间隔，单位：分钟
                sendTimes: '', //发放次数
                lastSendTime: '' //最后一次发放时间
            };
        },
        submitForm() {
            delete this.shopIncome.user;
            delete this.shopIncome.grade;
            delete this.shopIncome.agentLevel;
            if (this.shopIncomeState == 'add') {
                this.$refs.shopIncomeForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/model/income/add`, { ...this.shopIncome }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopIncomeList();
                                this.resetDialog();
                                this.getShopIncomeList();
                            }
                        });
                    }
                });
            } else if (this.shopIncomeState == 'edit') {
                this.$refs.shopIncomeForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/model/income/edit`, { ...this.shopIncome }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopIncomeList();
                                this.resetDialog();
                                this.getShopIncomeList();
                            }
                        });
                    }
                });
            }
        },
        addShopIncome() {
            this.showDialog = true;
            this.shopIncomeState = 'add';
        },
        checkShopIncome(shopIncomeId) {
            console.log(shopIncomeId);
            this.currentShopIncomeId = shopIncomeId;
            this.clearTypeId = true;

            this.getShopIncomeById();
            this.showDialog = true;
            this.shopIncomeState = 'check';
        },
        editShopIncome(shopIncomeId) {
            console.log('shopIncome', shopIncomeId);
            this.clearTypeId = true;
            if (shopIncomeId) {
                this.currentShopIncomeId = shopIncomeId;
                this.getShopIncomeById();
            } else {
                this.shopIncome = { ...this.shopIncome, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.shopIncomeState = 'edit';
        },
        deleteShopIncome(shopIncomeId) {
            let ids = '';
            if (shopIncomeId) {
                ids = shopIncomeId;
            } else {
                ids = this.multipleSelection.map((shopIncome) => shopIncome.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/model/income/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetShopIncomeList();
                            this.getShopIncomeList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshShopIncomeList() {
            this.resetShopIncomeList();
            this.getShopIncomeList();
        },
        getShopIncomeList(query = {}) {
            this.loading = true;
            get(`/model/income/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.shopIncomeList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getShopIncomeById() {
            get(`/model/income/get`, { id: this.currentShopIncomeId }).then((res) => {
                if (res.success) {
                    this.shopIncome = { ...this.shopIncome, ...res.shopIncome };
                }
            });
        },
        /**
         * 导出信息
         */
        exportShopIncomeList() {
            //this.btnLoading = true;
            exprotExcel(`/model/income/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/model/income/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/model/income/importData`, formData);
            this.refreshShopIncomeList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getShopIncomeList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getShopIncomeList();
        },

        // 手动发放
        sendDividend(item) {
            this.$confirm('即将发放分红, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                get('/model/income/send', { id: item.id }).then((res) => {
                    if (res.success) {
                        this.$message({
                            message: res.data,
                            type: 'success',
                            duration: 2000
                        });
                        this.refreshShopIncomeList();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            }).catch(() => {
            });
        },

        getValue(value) {
            this.shopIncome.typeId = value;
        },

        // 获取发放方式枚举
        getIncomeExecuteWayEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'income_execute_way'
            }).then((res) => {
                if (res.success) {
                    this.incomeExecuteWayEnumList = res.enumList;
                }
            });
        },

        // 获取发放类型枚举
        getIncomeSendWayEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'income_send_way'
            }).then((res) => {
                if (res.success) {
                    this.incomeSendWayEnumList = res.enumList;
                }
            });
        },

        // 获取发放范围枚举
        getIncomeSendTypeEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'income_send_type'
            }).then((res) => {
                if (res.success) {
                    this.incomeSendTypeEnumList = res.enumList;
                }
            });
        },

        // 获取货币类型枚举
        getCurrencyTypeEnum() {
            get('/mpp/utils/getEnum', {
                enumType: 'currency_type'
            }).then((res) => {
                if (res.success) {
                    this.currencyTypeEnumList = res.enumList;
                }
            });
        },

        // 获取用户等级
        getMppGradeList() {
            get(`/mpp/grade/findList`, { pageNum: 1, pageSize: 100 }).then((res) => {
                if (res.success && res.code == 200) {
                    this.mppGradeList = res.page.list;
                }
            });
        },

        // 获取代理等级
        getAgentLevelEnum() {
            get('/mpp/app/agentlevel/findAll').then((res) => {
                if (res.success) {
                    this.agentLevelEnumList = res.list;
                }
            });
        },

        // 计算发放货币
        computeCurrencyType(type) {
            for (let i = 0; i < this.currencyTypeEnumList.length; i++) {
                if (this.currencyTypeEnumList[i].key == type) {
                    return this.currencyTypeEnumList[i].value;
                }
            }
        },

        computeSendType(type) {
            for (let i = 0; i < this.incomeSendTypeEnumList.length; i++) {
                if (this.incomeSendTypeEnumList[i].key == type) {
                    return this.incomeSendTypeEnumList[i].value;
                }
            }
        },

        computeSendWay(type) {
            for (let i = 0; i < this.incomeSendWayEnumList.length; i++) {
                if (this.incomeSendWayEnumList[i].key == type) {
                    return this.incomeSendWayEnumList[i].value;
                }
            }
        },

        computeExecuteWay(type) {
            for (let i = 0; i < this.incomeExecuteWayEnumList.length; i++) {
                if (this.incomeExecuteWayEnumList[i].key == type) {
                    return this.incomeExecuteWayEnumList[i].value;
                }
            }
        }
    }
};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
